import { Separator } from '@repo/ui/separator';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@repo/ui/sidebar';
import type { CSSProperties } from 'react';
import { Navigate, Outlet, useRouteLoaderData } from 'react-router';
import { AppBreadcrumb } from '@/components/layout/app-breadcrumb';
import { AppSidebar } from '@/components/layout/app-sidebar';
import { UnsavedChangesProvider } from '@/providers/unsaved-changes';
import type { rootLoader } from '@/root';

export const AuthenticatedLayout = () => {
  const rootLoaderData = useRouteLoaderData<Awaited<ReturnType<typeof rootLoader>>>('root');

  if (!rootLoaderData?.session?.user || !rootLoaderData?.session?.isAuthenticated) {
    return <Navigate replace to="/auth/signin" />;
  }

  return (
    <UnsavedChangesProvider>
      <main className="w-screen min-w-0 max-w-full">
        <SidebarProvider
          style={{ '--sidebar-width': 'clamp(16rem, 20vw, 24rem)' } as CSSProperties}
        >
          <AppSidebar />
          <SidebarInset className="min-w-0">
            <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4">
              <SidebarTrigger className="-ml-1" />
              <Separator className="me-2 h-4" orientation="vertical" />
              <AppBreadcrumb />
            </header>
            <div className="flex w-full flex-1 flex-col gap-4 p-4">
              <Outlet />
            </div>
          </SidebarInset>
        </SidebarProvider>
      </main>
    </UnsavedChangesProvider>
  );
};
